import { render, staticRenderFns } from "./TeamMemberSettings.vue?vue&type=template&id=1da21247&scoped=true&"
import script from "./TeamMemberSettings.vue?vue&type=script&lang=js&"
export * from "./TeamMemberSettings.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberSettings.vue?vue&type=style&index=0&id=1da21247&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da21247",
  null
  
)

export default component.exports